<template>
  <div class="exam container">
    <div class="box">
      <el-form
        :model="searchForm"
        class="search_form"
        :inline="true"
        size="small"
      >
        <el-form-item prop="title">
          <el-input v-model="searchForm.title" placeholder="搜索"
            ><el-button
              slot="append"
              size="small"
              icon="el-icon-search"
              @click="getList"
            ></el-button
          ></el-input>
        </el-form-item>
        <el-form-item prop="status">
          <el-radio-group v-model="searchForm.status" @change="getList">
            <el-radio-button
              v-for="item in statusList"
              :label="item.value"
              :key="item.value"
              >{{ item.label }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="showSetType = true"
            >新建考试</el-button
          >
          <el-button
            type="primary"
            plain
            @click="
              $router.push({
                path: '/classCourse/exam/examBank',
                query: { ...$route.query },
              })
            "
            >试卷库</el-button
          >
        </el-form-item>
      </el-form>
      <div class="list">
        <template v-if="total > 0">
          <div class="row" v-for="item in list" :key="item.id">
            <div class="left">
              <p class="title" @click="goDetail(item.examId, item.random)">
                {{ item.title }}
              </p>
              <p class="time">
                <i class="el-icon-time"></i> 作答时间：
                {{ formatDate(item.startTime, "YYYY-MM-DD HH:mm") }} 至
                {{ formatDate(item.endTime, "YYYY-MM-DD HH:mm") }}
              </p>
            </div>
            <div class="btns">
              <el-button type="text" @click="handleSetEnd(item.releaseId)"
                >设置为期末成绩</el-button
              >
              <el-button type="text" @click="handleEdit(item.releaseId)"
                >修改设置</el-button
              >
              <el-button type="text" @click="handleDel(item.releaseId)"
                >删除</el-button
              >
            </div>
            <div class="right">
              <div class="count">
                <b>{{ item.notReviewNum }}</b> 待批 |
                {{ item.submittedNum - item.notReviewNum }} 已批
              </div>
              <el-button
                type="primary"
                size="medium"
                round
                @click="handleReview(item.releaseId, item.title)"
                >批阅</el-button
              >
            </div>
          </div>
          <div class="foot_page">
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :page-size="searchForm.limit"
              :current-page.sync="searchForm.page"
              :total="total"
              @current-change="getList"
            ></el-pagination>
          </div>
        </template>
        <el-empty v-else description="暂无考试"></el-empty>
      </div>
    </div>

    <el-dialog title="新建考试" :visible.sync="showSetType" width="30%" center>
      <div style="margin-bottom: 20px">
        <el-radio v-model="isAuto" :label="false">手动创建试卷</el-radio>
        <p style="padding-left: 15px; font-size: 12px; color: #909399">
          （手动编辑创建新试卷）
        </p>
      </div>
      <div>
        <el-radio v-model="isAuto" :label="true">自动随机组卷</el-radio>
        <p style="padding-left: 15px; font-size: 12px; color: #909399">
          （系统从已有题库中随机选题组卷）
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showSetType = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleSet"
          >下一步</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="随机组卷列表"
      :visible.sync="showRandom"
      width="50%"
      center
    >
      <el-table :data="rList" stripe class="r-list">
        <el-table-column prop="title" label="考试">
          <template slot-scope="scope">
            <span
              style="cursor: pointer"
              @click="
                $router.push({
                  path: '/classCourse/exam/detail',
                  query: {
                    ...$route.query,
                    examId: scope.row.examId,
                  },
                })
              "
              >{{ scope.row.title }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="200"
          align="center"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/utils/index";
import { releaseList, delReleaseExam, randomList, setEnd } from "@/api/exam";

export default {
  data() {
    return {
      formatDate,
      searchForm: {
        classId: this.$route.query.id,
        page: 1,
        limit: 5,
        title: "",
        status: null,
      },
      total: 2,
      statusList: [
        { label: "全部", value: null },
        { label: "未开始", value: "NOT_STARTED" },
        { label: "进行中", value: "STARTED" },
        { label: "已结束", value: "ENDED" },
      ],
      list: [],
      rList: [],
      showRandom: false,
      showSetType: false,
      isAuto: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 考试列表
    getList() {
      this.$loading.show();
      releaseList(this.searchForm).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.list = data.records;
          this.total = data.total;
        } else {
          this.$message.error(msg);
        }
      });
    },
    getRandomList(examId) {
      this.$loading.show();
      randomList(examId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.rList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 设置期末考试
    handleSetEnd(releaseId) {
      this.$confirm("确定要把本场考试成绩设置为期末成绩吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          setEnd(releaseId).then(({ code, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.$message.success("设置成功");
              this.$emit("updateInfo");
            } else {
              this.$message.error(msg);
            }
          });
        })
        .catch(() => {});
    },
    // 修改设置
    handleEdit(releaseId) {
      this.$router.push({
        path: "/classCourse/exam/settings",
        query: {
          ...this.$route.query,
          releaseId,
        },
      });
    },
    // 删除
    handleDel(releaseId) {
      this.$confirm("确定要删除该试卷吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delReleaseExam(releaseId).then(({ code, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(msg);
            }
          });
        })
        .catch(() => {});
    },
    handleReview(releaseId, examTitle) {
      this.$router.push({
        path: "/classCourse/exam/review",
        query: {
          ...this.$route.query,
          releaseId,
          examTitle,
        },
      });
    },
    // 查看试卷详情
    goDetail(examId, random) {
      if (random) {
        this.getRandomList(examId);
        this.showRandom = true;
      } else
        this.$router.push({
          path: "/classCourse/exam/detail",
          query: {
            ...this.$route.query,
            examId,
          },
        });
    },
    // 点击新建
    handleSet() {
      if (this.isAuto)
        this.$router.push({
          path: "/classCourse/exam/autoSetExam",
          query: { ...this.$route.query },
        });
      else
        this.$router.push({
          path: "/classCourse/exam/setExam",
          query: { ...this.$route.query },
        });
    },
  },
};
</script>

<style lang="less" scoped>
.exam {
  height: 100%;
  text-align: left;
  .box {
    padding: 25px 35px;
    background-color: #fff;
    ::v-deep .search_form {
      .el-form-item {
        margin-right: 50px;
        .el-input-group__append {
          background-color: teal;
          border-color: teal;
          color: #fff;
        }
      }
    }
    .list {
      .row {
        position: relative;
        padding: 25px 0;
        border-bottom: solid 1px #f2f2f2;
        &:hover {
          .btns {
            opacity: 1;
          }
        }
        .left {
          display: inline-block;
          width: 55%;
          vertical-align: middle;
          .title {
            color: #303133;
            transition: all 0.3s ease;
            cursor: pointer;
            &:hover {
              color: teal;
            }
          }
          .time {
            margin-top: 10px;
            color: #909399;
          }
        }
        .btns {
          display: inline-block;
          vertical-align: middle;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .right {
          display: inline-block;
          margin-left: 75px;
          .count {
            display: inline-block;
            width: 120px;
            margin-right: 30px;
            text-align: center;
            color: #909399;
            b {
              font-size: 24px;
              color: #303133;
            }
          }
        }
      }
      ::v-deep .foot_page {
        margin-top: 20px;
        text-align: right;
        .el-pagination__total {
          float: left;
        }
      }
    }
  }
  ::v-deep .r-list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>